import { mount } from "svelte";
import DonationForm from "@/components/donation-form/DonationForm.svelte";

document.querySelectorAll('[data-svelte="donation-form"]').forEach((el) => {
  const props = el.dataset.props ? JSON.parse(el.dataset.props) : {};
  mount(DonationForm, { target: el, props });
});
